import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery.ts";
import { useLocation } from "react-router-dom";
import useQuery from "utils/hooks/useQuery.ts";
import { decode } from "js-base64";
import { useEffect } from "react";
import { getParsedData } from "utils/misc.tsx";
import { getApiBaseUrl } from "app/shared/utils.ts";
import { TELEGRAM_OAUTH_STATE_PARAM } from "common/constants.ts";

const useTelegramLogin = () => {
  const { getUpdatedPath } = useHistoryWithQuery();
  const location = useLocation();
  const query = useQuery();
  const state = query.get(TELEGRAM_OAUTH_STATE_PARAM) || "";
  const queryHash = location.hash.replace("#tgAuthResult=", "");
  let decodedHash = "";
  try {
    decodedHash = decode(queryHash);
  } catch {}
  const telegramUserData = getParsedData(decodedHash);
  const isTelegramLogin = !!telegramUserData && !!state;

  useEffect(() => {
    if (telegramUserData && state) {
      let params = {};
      for (let key in telegramUserData) {
        if (QUERY_KEYS.includes(key) && telegramUserData[key]) {
          params[key] = telegramUserData[key];
        }
        if (telegramUserData.hash) {
          params["code"] = telegramUserData.hash;
        }
        if (state) {
          params[TELEGRAM_OAUTH_STATE_PARAM] = state;
        }
      }

      const oauthCallbackUrl = getUpdatedPath(
        params,
        undefined,
        getApiBaseUrl().concat("/oauth_callback/")
      );
      window.open(oauthCallbackUrl, "_self");
    }
  }, [decodedHash, state]);

  return {
    isTelegramLogin,
  };
};

export default useTelegramLogin;

const QUERY_KEYS = [
  "id",
  "first_name",
  "last_name",
  "username",
  "photo_url",
  "auth_date",
  "hash",
  "code",
  "state",
];
